// extracted by mini-css-extract-plugin
export default {"matrixContainer":"ReadOnlyEligibilityMatrixDialog_matrixContainer__eV+4j","gridContainer":"ReadOnlyEligibilityMatrixDialog_gridContainer__UQUzX"};